import { useEffect } from "react";
import { usePlayerEngine } from "../../../../runtime/provider";

/**
 * Web build: Ads are currently disabled (we don't run the VAST + expo-audio ad engine).
 *
 * IMPORTANT: Keep this file free of `expo-audio` imports. On web, the `expo-audio`
 * package does not expose the React hooks we use on native, and importing it can
 * crash the app at module-eval time.
 */
export function usePlayerAds(): void {
  const player = usePlayerEngine();
  useEffect(() => {
    // Ensure the orchestrator never sees an ad engine on web.
    player.controller.setRuntimeAdEngine(null);
    return () => player.controller.setRuntimeAdEngine(null);
  }, [player]);
}
